type StatusDrawerIconProps = {
  className?: string;
  size?: number;
};

export function StatusDrawerIcon({ className, size = 20 }: StatusDrawerIconProps) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      className={className ? `starcrew-status-drawer-icon ${className}` : "starcrew-status-drawer-icon"}
    >
      <path
        className="starcrew-status-drawer-icon__disc"
        d="M513.17857828 882.78857422c-204.13235277 0-369.61441064-165.48205789-369.61441065-369.60999595 0-204.13235277 165.48205789-369.61441064 369.61441064-369.61441064C717.30210237 143.56416762 882.78857422 309.04622551 882.78857422 513.17857828 882.78857422 717.30210237 717.30651633 882.78857422 513.17857828 882.78857422z"
      />
      <path
        className="starcrew-status-drawer-icon__arrow"
        d="M645.69135162 587.33187842a35.31319772 35.31319772 0 0 0 51.0275709-48.82049537l-158.33554986-169.50334831-0.58266745-0.60915275c-14.05465255-14.36364328-37.35253488-14.12527908-51.10261143 0.68419326l-157.13048627 169.23849955-0.56942553 0.63122337a35.31319772 35.31319772 0 0 0 2.41895443 49.2795671l0.62680867 0.56501082a35.31319772 35.31319772 0 0 0 49.2795671-2.41895369L512.65329398 444.92699531 645.10427019 586.72272565l0.58266745 0.60915277z"
      />
    </svg>
  );
}
